module.exports = __webpack_public_path__ + "static/media/pay_now.fd9fa439.svg";